export default import.meta.ROLLUP_FILE_URL_5cfU$U3OOdde6xlydEN7xw